export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/about-arc-point.0819f21d-fa3e12.svg";